import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import Box from '@nubank/nuds-web/components/Box/Box';

export const Container = styled(Box)`
  border-top: 2px solid ${nuDSColor('black')};
  padding: 0.625rem 0 4rem;
  display: flex;
  justify-content: space-between;

  &:last-child {
    padding-bottom: 0;
  }
`;

Container.displayName = 'Container';
